/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_No_Duration_ToastInputs */

const en_segment_event_group_no_duration_toast = /** @type {(inputs: Segment_Event_Group_No_Duration_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unable to segment Event Group. No duration detected.`)
};

const fr_segment_event_group_no_duration_toast = /** @type {(inputs: Segment_Event_Group_No_Duration_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de segmenter le groupe d'evenements. Aucune duree detectee.`)
};

const de_segment_event_group_no_duration_toast = /** @type {(inputs: Segment_Event_Group_No_Duration_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisgruppe konnte nicht segmentiert werden. Keine Dauer erkannt.`)
};

const it_segment_event_group_no_duration_toast = /** @type {(inputs: Segment_Event_Group_No_Duration_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile segmentare il gruppo di eventi. Nessuna durata rilevata.`)
};

const ru_segment_event_group_no_duration_toast = /** @type {(inputs: Segment_Event_Group_No_Duration_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось выделить группу событий. Продолжительность не определена.`)
};

const es_segment_event_group_no_duration_toast = /** @type {(inputs: Segment_Event_Group_No_Duration_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se puede segmentar el grupo de eventos. No se detectó duración.`)
};

const zh_cn2_segment_event_group_no_duration_toast = /** @type {(inputs: Segment_Event_Group_No_Duration_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法对事件组进行分段。未检测到持续时间。`)
};

const ja_segment_event_group_no_duration_toast = /** @type {(inputs: Segment_Event_Group_No_Duration_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント グループをセグメント化できません。期間が検出されませんでした。`)
};

const hi_segment_event_group_no_duration_toast = /** @type {(inputs: Segment_Event_Group_No_Duration_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट ग्रुप को सेगमेंट करने में असमर्थ। कोई अवधि निर्धारित नहीं हुई।`)
};

const pt_pt2_segment_event_group_no_duration_toast = /** @type {(inputs: Segment_Event_Group_No_Duration_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível segmentar o grupo de eventos. Nenhuma duração detectada.`)
};

/**
* | output |
* | --- |
* | "Unable to segment Event Group. No duration detected." |
*
* @param {Segment_Event_Group_No_Duration_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_no_duration_toast = /** @type {((inputs?: Segment_Event_Group_No_Duration_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_No_Duration_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_segment_event_group_no_duration_toast(inputs)
	if (locale === "de") return de_segment_event_group_no_duration_toast(inputs)
	if (locale === "it") return it_segment_event_group_no_duration_toast(inputs)
	if (locale === "ru") return ru_segment_event_group_no_duration_toast(inputs)
	if (locale === "es") return es_segment_event_group_no_duration_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_segment_event_group_no_duration_toast(inputs)
	if (locale === "ja") return ja_segment_event_group_no_duration_toast(inputs)
	if (locale === "hi") return hi_segment_event_group_no_duration_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_segment_event_group_no_duration_toast(inputs)
	return en_segment_event_group_no_duration_toast(inputs)
});